import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
import routes from "./modules/routes-list";
import { isMenuBarsManagementHidden } from "@/services/featureConfig";
import { trackPageImpression } from "@voyage-metrics/sdk";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const hiddenBarRoutes = ["BarList", "MenuBarsRecucler"];

router.beforeEach((to, from, next) => {
  if (
    isMenuBarsManagementHidden() &&
    to.name &&
    hiddenBarRoutes.includes(to.name as string)
  ) {
    next({ name: "MenuList" });
    return;
  }

  const currentRefresh: string | null | undefined =
    store.getters.getRefreshToken;
  const routerList: string[] = store.getters.FULL_ROUTES;

  const requireAuth = to.matched.some((record) => record.meta.auth);
  let routrTo = false;
  for (let i = 0; i < routerList.length; i++) {
    if (to.name == routerList[i]) {
      routrTo = true;
    }
  }

  if (to.name !== "Login" && requireAuth && (!currentRefresh || !routrTo)) {
    if (!currentRefresh) {
      next("/login");
    } else {
      next("/forbidden");
    }
  } else {
    next();
  }
});

router.afterEach((to) => {
  const path = to.path === "/" ? "/home" : to.path;
  trackPageImpression(path);
});

export default router;
